import { apiPost } from '@services/service';
import { POST_RetrieveContactDetailsOnChange } from '@constants/end-points';
import { setLoading } from '@store/reducers/loadingSlice';
import { AppDispatch } from '@store/store'; // Import AppDispatch type

export const fetchContactDetails = async (dispatch: AppDispatch, payload: any) => {
    try {
        dispatch(setLoading(true)); 
        const response = await apiPost(POST_RetrieveContactDetailsOnChange, payload);
        const data = JSON.parse(response?.data?.contactdata || '[]')[0] || {}; // Prevent errors if response is empty

        dispatch(setLoading(false));

        return {
            ...data,
            UserId: [payload.contactid],
            phNumAlternateCountryCode: [""],
            countryId: [data?.countryId || ""], 
            phNumCountryCode: [data?.countryId || ""], 
            PhoneNumber: data.PhoneNumber.replace('+'+data.countrycode, ''),
            AlternatePhoneNumber: data.AlternatePhoneNumber.replace('+'+data.countrycode, '')
        };
    } catch (error: any) {
        dispatch(setLoading(false)); 
        throw new Error(error.message || "Failed to fetch contact details");
    }
};
